/// <reference path="../../_ext/Bases/GridBase.ts" />
namespace TabAurous.JobWork {

    @Serenity.Decorators.registerClass()
    export class JobWorkGrid extends Serenity.EntityGrid<JobWorkRow, any> {
        protected getColumnsKey() { return 'JobWork.JobWork'; }
        protected getDialogType() { return JobWorkDialog; }
        protected getIdProperty() { return JobWorkRow.idProperty; }
        protected getInsertPermission() { return JobWorkRow.insertPermission; }
        protected getLocalTextPrefix() { return JobWorkRow.localTextPrefix; }
        protected getService() { return JobWorkService.baseUrl; }
        protected get_ExtGridOptions() { return Q.deepClone(q.DefaultMainGridOptions) }
        public rowSelection: Serenity.GridRowSelectionMixin;
        private autoSize;
        constructor(container: JQuery) {
            super(container); 
        }

        protected addButtonClick() {
            
            let now = new Date();
            var dt = now.getDay();
            var mt = now.getMonth();
            var yr = now.getUTCFullYear();
            var hr = now.getUTCHours();
            var mn = now.getUTCMinutes();
            var sc = now.getUTCSeconds();

            var voucherNo = FormatHelper.GetVoucherNo(40);

            this.editItem(<JobWorkRow>{
                VoucherNo: voucherNo,
                Line_No: 0,
                TransDate: now.toDateString(),
                CompanyId: Q.Authorization.userDefinition.CompanyId,
                FinancialYearId: Q.Authorization.userDefinition.FinancialYearId,
                UserId: Q.Authorization.userDefinition.UserId,
                CurrencyId: Q.Authorization.userDefinition.CurrencyId,
                VoucherTypeId: 40,
                
                       
            });
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }


        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}